import CryptoJS from 'crypto-js'

export const convertPlantextToEncrypted = (data: any) => {
  const secretKey = process.env.NEXT_PUBLIC_AES_SECRET_KEY!
  const key = CryptoJS.enc.Hex.parse(secretKey)

  // Convert plaintext data to a UTF-8 string
  const cryptString = CryptoJS.enc.Utf8.parse(JSON.stringify(data))

  // Generate a random 16-byte IV
  const iv = CryptoJS.lib.WordArray.random(16)

  // Encrypt the data using AES in CBC mode with PKCS7 padding
  const encrypted = CryptoJS.AES.encrypt(cryptString, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })

  // Concatenate IV and ciphertext (Base64 decoded encrypted data)
  const combined = iv.concat(CryptoJS.enc.Base64.parse(encrypted.toString()))

  // Encode the combined result to Base64
  const base64Encoded = CryptoJS.enc.Base64.stringify(combined)

  return { data: base64Encoded }
}

export const convertEncryptedToPlantext = (encryptedData: any) => {
  const secretKey = process.env.NEXT_PUBLIC_AES_SECRET_KEY!
  const key = CryptoJS.enc.Hex.parse(secretKey)

  // Decode the Base64-encoded string back to a WordArray
  const combined = CryptoJS.enc.Base64.parse(encryptedData)

  // Extract the IV (first 16 bytes) from the combined WordArray
  const iv = CryptoJS.lib.WordArray.create(combined.words.slice(0, 16 / 4), 16)

  // Extract the ciphertext (remaining bytes) from the combined WordArray
  const ciphertext = CryptoJS.lib.WordArray.create(combined.words.slice(16 / 4))

  // Decrypt the ciphertext using AES in CBC mode with PKCS7 padding
  const decrypted = CryptoJS.AES.decrypt({ ciphertext: ciphertext } as CryptoJS.lib.CipherParams, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })

  // Convert the decrypted WordArray to a UTF-8 string
  const plaintext = decrypted.toString(CryptoJS.enc.Utf8)

  // Parse the JSON string back into a JavaScript object
  return JSON.parse(plaintext)
}
